import { toast } from 'react-toastify';
import { usersApi } from 'entities/users';

type CitiesListType = {
  name: string;
  country_id: number;
  id: number;
};

const useCityApi = usersApi.injectEndpoints({
  endpoints: (builder) => ({
    getCitiesSet: builder.query<CitiesListType[], any>({
      query: ({ country_id }) => {
        const url = '/account/admin/dicts/cities/';
        if (country_id) {
          return { url, params: { country_id } };
        }
        return { url };
      },
    }),
    addCities: builder.mutation({
      query: ({ body }) => ({
        url: '/account/admin/dicts/cities/',
        method: 'POST',
        body,
      }),
      invalidatesTags: (result, error, arg) => {
        const error_message = error?.status;
        if (error) {
          toast.error(error_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.success('Вы успешно добавили город', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        return [
          { type: 'User', id: arg.id },
          { type: 'Users', id: 'ALL' },
        ];
      },
    }),
    editCities: builder.mutation({
      query: ({ id, body }) => ({
        url: `/account/admin/dicts/cities/${id}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: (result, error, arg) => {
        const error_message = error?.status;
        if (error) {
          toast.error(error_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.success('Вы успешно изменили город', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        return [
          { type: 'User', id: arg.id },
          { type: 'Users', id: 'ALL' },
        ];
      },
    }),
    deleteCities: builder.mutation({
      query: ({ id }: { id: number }) => ({
        url: `/account/admin/dicts/cities/${id}`,
        method: 'DELETE',
        body: { id },
      }),
      invalidatesTags: (result, error, arg) => {
        const error_message = error?.status;
        if (error) {
          toast.error(error_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.success('Вы успешно удалили город', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        return [
          { type: 'User', id: arg.id },
          { type: 'Users', id: 'ALL' },
        ];
      },
    }),
  }),
});

export const { useGetCitiesSetQuery, useAddCitiesMutation, useEditCitiesMutation, useDeleteCitiesMutation } =
  useCityApi;
